// uses ./appSettings.less
import PropTypes from 'prop-types';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import ConfirmationModal from '../common/ConfirmationModal';
import { fetchUserSettingsToken, closeSettingsInfoPopup } from '../common/appSettingsActionCreators';
import getOpenSettings from './AppSettingsHelper';

// TODO rename it to UserSettingsModal
function AppSettings(props) {
    useEffect(() => {
        props.dispatchFetchUserSettingsToken(props.appId);
    }, [props.appId]);

    if (!props.settingsURL) {
        return null;
    }

    const title = `Configure ${props.name}`;
    const openSettings = getOpenSettings(
        pick(props, ['settingsURL', 'token', 'saveUrl', 'domain', 'appId', 'dispatchCloseSettingsInfoPopup']),
        { enableAppConfigurationUpdates: false }
    );

    return (
        <ConfirmationModal
            className="appSettings"
            closeHandler={props.dispatchCloseSettingsInfoPopup}
            title={title}
            confirmHandler={openSettings}
            isFetching={props.isFetching}
        >
            <p>Configuration for {props.name} will open in&nbsp;a&nbsp;new&nbsp;window.</p>
        </ConfirmationModal>
    );
}

AppSettings.propTypes = {
    appId: PropTypes.string,
    name: PropTypes.string,
    settingsURL: PropTypes.string,
    isFetching: PropTypes.bool,
    token: PropTypes.string,
    saveUrl: PropTypes.string,
    domain: PropTypes.string,
    dispatchFetchUserSettingsToken: PropTypes.func,
    dispatchCloseSettingsInfoPopup: PropTypes.func,
};

const mapDispatchToProps = {
    dispatchFetchUserSettingsToken: fetchUserSettingsToken,
    dispatchCloseSettingsInfoPopup: closeSettingsInfoPopup,
};

export default connect((state) => state.appSettings, mapDispatchToProps)(AppSettings);
